<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="adc">
<p class="center"><em>Other Books by Rick Shelley</em></p>
<p class="center">THE BUCHANAN CAMPAIGN<br/>THE FIRES OF COVENTRY<br/>RETURN TO CAMEREIN</p>
<p class="center">OFFICER-CADET<br/>LIEUTENANT<br/>CAPTAIN<br/>MAJOR<br/>LIEUTENANT COLONEL<br/>COLONEL</p>
<p class="center">DEEP STRIKE<br/>SUCKER PUNCH</p>
<p class="center">SON OF THE HERO<br/>THE HERO OF VARAY<br/>THE HERO KING</p>
<p class="center">THE WIZARD AT MECQ<br/>THE WIZARD AT HOME</p>
<p class="center"><em>All available as ebooks from Jabberwocky Literary Agency</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781936535408_epub_adc_r1.vue?4bfa5c0e